module.exports = __webpack_public_path__ + "static/media/logo-blue.22c193ba.png";